import { getCities } from '@/modules/Employee/services'
import { FilterSelect } from '@/components/ui/filters'
import { useQuery } from '@tanstack/react-query'
import { FieldValues, Path, UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

interface ProvinceSelectProps<T extends FieldValues> {
    country: string
    control: UseFormReturn<T, any, any>['control']
    name: Path<T>
    multiple?: boolean
    disabled?: boolean
    label?: string
    onChangeAfterHookForm?: () => void
}

const ProvinceSelect = <T extends FieldValues>({
    country,
    control,
    name,
    multiple,
    label,
    disabled = false,
    onChangeAfterHookForm,
}: ProvinceSelectProps<T>) => {
    const { data: cities } = useQuery({
        queryKey: [QUERY_KEYS.CITIES, country],
        queryFn: () => getCities(country),
    })
    const { t } = useTranslation()
    return (
        <FilterSelect
            control={control}
            name={name}
            label={t(label || 'province')}
            placeholder={t(label || 'province')}
            options={cities || []}
            showClearButton={false}
            disabled={disabled}
            multiple={multiple}
            onChangeAfterHookForm={onChangeAfterHookForm}
        />
    )
}

export default ProvinceSelect
